"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupportedEip6963Provider = void 0;
// https://github.com/WalletConnect/EIP6963/blob/master/src/utils/constants.ts
var SupportedEip6963Provider;
(function (SupportedEip6963Provider) {
    SupportedEip6963Provider["Brave"] = "Brave";
    SupportedEip6963Provider["Enkrypt"] = "Enkrypt";
    SupportedEip6963Provider["Zerion"] = "Zerion";
    SupportedEip6963Provider["TokenPocket"] = "TokenPocket";
    SupportedEip6963Provider["Iron"] = "Iron";
    SupportedEip6963Provider["Rainbow"] = "Rainbow";
    SupportedEip6963Provider["Phantom"] = "Phantom";
    SupportedEip6963Provider["OKX"] = "OKX";
    SupportedEip6963Provider["Spot"] = "Spot";
    SupportedEip6963Provider["XDEFI"] = "XDEFI";
    SupportedEip6963Provider["Talisman"] = "Talisman";
    SupportedEip6963Provider["Frontier"] = "Frontier";
    SupportedEip6963Provider["SafePal"] = "SafePal";
    SupportedEip6963Provider["Sequence"] = "Sequence";
    SupportedEip6963Provider["RabbyWallet"] = "Rabby Wallet";
    SupportedEip6963Provider["TrustWallet"] = "Trust Wallet";
    SupportedEip6963Provider["Coinbase"] = "Coinbase";
    SupportedEip6963Provider["MetaMask"] = "MetaMask";
    SupportedEip6963Provider["CryptoWallet"] = "Crypto.com Wallet";
    SupportedEip6963Provider["RoninWallet"] = "Ronin Wallet";
    SupportedEip6963Provider["MetaMaskInstitutional"] = "MetaMask Institutional";
    SupportedEip6963Provider["BitgetWallet"] = "Bitget Wallet";
    SupportedEip6963Provider["Fluvi"] = "Fluvi";
    SupportedEip6963Provider["SafeheronWallet"] = "Safeheron Wallet";
})(SupportedEip6963Provider = exports.SupportedEip6963Provider || (exports.SupportedEip6963Provider = {}));
